// TICKET-566: These IDs filter the modalities returned by GetModalityList
// to display only the entries shown under the 'Services' heading in the search form.
export const SERVICE_IDS = [22, 1, 43, 25, 44, 24, 40, 39, 45, 26, 46, 47, 48, 49, 54, 55, 57];

export const MESSAGE_MAX_CHAR_LENGTH = 10000;

export const SEARCH_DEFAULTS = {
    radius: 10,
};
